/*
  Rabattmeldingen (2026-11-01): vises når informasjonskapselen discount_code finnes (Shopify setter den ved /discount/<KODE>),
  eller når handlekurven har attributtet kilde: solgt-vare og en kode (solgte varer, serie 22, data-kurv fra Liquid), til kunden lukker den. Lukket huskes i økta per kode (sessionStorage), bare med ja til preferanser (fra 22b). Teksten settes med textContent, koden kan ikke injisere HTML.
*/
(() => {
  const melding = document.getElementById('RabattMelding');
  if (!melding) return;

  // «Lukket» huskes i sessionStorage bare med uttrykkelig ja til preferanser (ekomloven § 3-15), ellers bare på denne siden.
  function samtykke() {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.currentVisitorConsent !== 'function') return null;
    try { return (cp.currentVisitorConsent() || {}).preferences === 'yes'; } catch (_) { return false; }
  }
  // Venter til samtykke-API-et svarer (maks 3 s), så en som har lukket meldingen med ja ikke ser den blinke
  function nårSamtykket(ferdig) {
    const start = Date.now();
    let bedt = false;
    (function vent() {
      const ja = samtykke();
      if (ja !== null) return ferdig(ja);
      if (!bedt && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        bedt = true;
        try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {}); } catch (_) {}
      }
      if (Date.now() - start > 3000) return ferdig(false);
      setTimeout(vent, 100);
    })();
  }

  function vis(kode) {
    if (!kode || kode.length > 40) return;
    const nokkel = 'gg-rabattmelding-lukket:' + kode.toUpperCase();
    nårSamtykket((ja) => {
      if (ja) { try { if (sessionStorage.getItem(nokkel)) return; } catch (_) {} }
      const tekst = (melding.dataset.tekst || '').split('[kode]').join(kode.toUpperCase());
      melding.hidden = false;
      // Teksten settes litt etter at området er synlig, så skjermlesere oppfatter endringen og leser den opp (role="status")
      setTimeout(() => { melding.querySelector('.rm__tekst').textContent = tekst; }, 150);
      const lukk = melding.querySelector('.rm__lukk');
      lukk.addEventListener('click', () => {
        const haddeFokus = document.activeElement === lukk;
        melding.hidden = true;
        if (samtykke() === true) { try { sessionStorage.setItem(nokkel, '1'); } catch (_) {} }
        // Fokus flyttes til innholdet, så det ikke forsvinner med knappen
        const main = document.getElementById('main-content');
        if (haddeFokus && main) { main.setAttribute('tabindex', '-1'); main.focus({ preventScroll: true }); }
      });
    });
  }

  // 1. Kapselen fra /discount/<KODE> (forsidebanneret)
  const rad = document.cookie.split(';').map((c) => c.trim()).find((c) => c.startsWith('discount_code='));
  if (rad) {
    let kode = '';
    try { kode = decodeURIComponent(rad.slice('discount_code='.length)).trim(); } catch (_) { return; }
    vis(kode);
    return;
  }
  // 2. Solgte varer (serie 22): koden ligger i handlekurven, lagt på med /cart/update.js. Liquid setter data-kurv bare når kurven har
  //    attributtet kilde: solgt-vare, så andre besøkende får ingen ekstra forespørsel. Har kurven varer, vises koden bare når Shopify
  //    sier at den gjelder (applicable). I en tom kurv er applicable alltid false, også for GB10 (lest 2026-11-01), så der vises den.
  if (melding.dataset.kurv !== '1') return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
    .then((svar) => (svar.ok ? svar.json() : null))
    .then((kurv) => {
      if (!kurv) return;
      const koder = Array.isArray(kurv.discount_codes) ? kurv.discount_codes : [];
      const tom = !(kurv.item_count > 0);
      const kode = koder.find((d) => d && typeof d.code === 'string' && d.code.trim() && (tom || d.applicable === true));
      if (kode) vis(kode.code.trim());
    })
    .catch(() => {});
})();
